meedy.factory('meedy.heartbeatService', ['$q', '$translate', '$injector', '$rootScope', 'meedy.baseService', 'meedy.objectHelper', 'meedyConfig',
    function ($q, $translate, $injector, $rootScope, baseService, objectHelper, config) {

        function HeartbeatService() {

            this.heartbeat = function () {
                var d = $q.defer();

                $rootScope.ignoreError.push(config.API_URL + '/heartbeat');
                baseService.get(config.API_URL + '/heartbeat').then(
                    function (successResponse) {
                        d.resolve(successResponse);
                    },
                    function (errorResponse) {
                        d.reject(errorResponse);
                    }
                );

                return d.promise;
            };

            this.heartbeatEDM = function(inEdm) {
                var d = $q.defer();

                if($injector.has('config') && inEdm) {
                    var edmConfig = $injector.get('config');

                    $rootScope.ignoreError.push(edmConfig.API_URL + '/meedy/authentication/heartbeat');
                    baseService.get(edmConfig.API_URL + '/meedy/authentication/heartbeat').then(
                        function (successResponse) {
                            d.resolve(successResponse);
                        },
                        function (errorResponse) {
                            d.reject(errorResponse);
                        }
                    );
                }

                return d.promise;

            }

        }

        return new HeartbeatService();
    }
]);
